import React, { useEffect, useState } from 'react';
import { Droplet, Menu, X, Phone } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };
  const navLinks = [{
    name: 'Services',
    id: 'services'
  }, {
    name: 'Why Us',
    id: 'why-us'
  }, {
    name: 'Gallery',
    id: 'gallery'
  }, {
    name: 'About',
    id: 'about'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-white/90 backdrop-blur-sm py-5'}`} data-id="element-160">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="flex justify-between items-center" data-id="element-162">
          {/* Logo */}
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} data-id="element-163">
            <div className="bg-blue-600 p-2 rounded-lg" data-id="element-164">
              <Droplet className="w-6 h-6 text-white fill-white" data-id="element-165" />
            </div>
            <div className="flex flex-col" data-id="element-166">
              <span className="font-bold text-xl leading-none text-slate-900 tracking-tight" data-id="element-167">
                Cox Pool
              </span>
              <span className="text-xs font-semibold text-blue-600 tracking-widest uppercase" data-id="element-168">
                Maintenance
              </span>
            </div>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-169">
            <div className="flex gap-6" data-id="element-170">
              {navLinks.map(link => <button key={link.name} onClick={() => scrollTo(link.id)} className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors" data-id="element-171">
                  {link.name}
                </button>)}
            </div>

            <div className="flex items-center gap-4 border-l pl-6 border-slate-200" data-id="element-172">
              <a href="tel:9034498879" className="flex items-center gap-2 text-slate-700 hover:text-blue-600 font-medium text-sm transition-colors" data-id="element-173">
                <Phone className="w-4 h-4" data-id="element-174" />
                (903) 449-8879
              </a>
              <button onClick={() => scrollTo('contact')} className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 rounded-full text-sm font-semibold transition-all shadow-sm hover:shadow-md" data-id="element-175">
                Get a Free Quote
              </button>
            </div>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden text-slate-600" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-176">
            {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-177" /> : <Menu className="w-6 h-6" data-id="element-178" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-slate-100 shadow-lg py-4 px-4 flex flex-col gap-4" data-id="element-179">
          {navLinks.map(link => <button key={link.name} onClick={() => scrollTo(link.id)} className="text-left py-2 text-slate-700 font-medium" data-id="element-180">
              {link.name}
            </button>)}
          <div className="h-px bg-slate-100 my-2" data-id="element-181" />
          <a href="tel:9034498879" className="flex items-center gap-2 text-slate-700 font-medium py-2" data-id="element-182">
            <Phone className="w-5 h-5 text-blue-600" data-id="element-183" />
            (903) 449-8879
          </a>
          <button onClick={() => scrollTo('contact')} className="bg-blue-600 text-white w-full py-3 rounded-lg font-semibold mt-2" data-id="element-184">
            Get a Free Quote
          </button>
        </div>}
    </nav>;
}